import React from 'react';
import { Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import './TopBar.css';

const TopBar = () => {
    return (
        <div className="top-bar">
            <div className="container top-bar-inner">
                <div className="top-bar-contact">
                    <div className="contact-item">
                        <Phone size={14} className="text-secondary" />
                        <span>+263 781 665 264</span>
                    </div>
                    <div className="contact-item hide-mobile">
                        <MapPin size={14} className="text-secondary" />
                        <span>Fife Avenue Mall, Harare</span>
                    </div>
                </div>
                <div className="top-bar-socials">
                    <a href="https://facebook.com/visionsports" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={14} /></a>
                    <a href="https://instagram.com/visionsports" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={14} /></a>
                    <span className="divider"></span>
                    <span className="tagline">Vision Sports Academy</span>
                </div>
            </div>
        </div>
    );
};

export default TopBar;
